// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"assessmentEditTab_buttonsContainer__XilWS"};